import { faEdit, faPlus } from "@fortawesome/free-solid-svg-icons";
import { useForm } from "react-hook-form";
import {
    CadastrarMotivoCancelamentoController,
    EditarMotivoCancelamentoController,
} from "../../../../../../Controllers/Geral/GestaoDeCadastros/MotivoCancelamento/MotivoCancelamentoController";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ListarModulosController } from "../../../../../../Controllers/Geral/Documentos/DocumentosController";
import { MotivoCancelamentoInterface } from "../../../../../../Interfaces/Geral/GestaoDeCadastro/MotivoCancelamento/MotivoCancelamentoInterfaces";
import useAsyncCallback from "../../../../../../hooks/useAsyncCallback";
import { Spinner } from "../../../../../Loding/SpinnerPadrao";
import OrSpinner from "../../../../../Utils/OrSpinner";
import useAsyncEffect from "../../../../../../hooks/useAsyncEffect";

interface ICreateUpdateMotivoCancelamentoProps {
    motivoCancelamento?: MotivoCancelamentoInterface;
    onSave?: () => void;
}

interface MotivoCancelamentoFormData {
    motivo: string;
    ID_TIPO_CASO: number;
}

export default function CreateUpdateMotivoCancelamento(
    props: ICreateUpdateMotivoCancelamentoProps
) {
    const { register, handleSubmit, formState, reset } = useForm();

    const {
        execute: CadastrarMotivoCancelamento,
        loading: CadastrarMotivoCancelamentoLoading,
    } = useAsyncCallback(CadastrarMotivoCancelamentoController);

    const {
        execute: EditarMotivoCancelamento,
        loading: EditarMotivoCancelamentoLoading,
    } = useAsyncCallback(EditarMotivoCancelamentoController);

    const { value: lstModulos, loading: lstModulosLoading } = useAsyncEffect(
        () => ListarModulosController(),
        []
    );

    const handleMotivoCancelamentoFormSubmit = (
        formData: MotivoCancelamentoFormData
    ) => {
        if (!props.motivoCancelamento) {
            CadastrarMotivoCancelamento({
                DS_MOTIVO_CANCELAMENTO: formData.motivo,
                ID_MOTIVO_CANCELAMENTO: 0,
                ID_TIPO_CASO: formData.ID_TIPO_CASO,
            }).then(() => {
                props.onSave?.();
                reset();
            });
        } else {
            EditarMotivoCancelamento({
                DS_MOTIVO_CANCELAMENTO: formData.motivo,
                ID_MOTIVO_CANCELAMENTO:
                    props.motivoCancelamento.ID_MOTIVO_CANCELAMENTO,
                ID_TIPO_CASO: formData.ID_TIPO_CASO,
            }).then(() => {
                props.onSave?.();
                reset();
            });
        }
    };

    return (
        <OrSpinner loading={lstModulosLoading} loadingSize="sm" spinner="capys">
            {!props.motivoCancelamento && (
                <h5 className="text-center">Cadastre Motivo de Cancelamento</h5>
            )}

            <form
                onSubmit={handleSubmit(handleMotivoCancelamentoFormSubmit)}
                className="w-100 d-flex justify-content-between flex-column align-itens-center"
            >
                <div className="w-100 h-100">
                    <label>Motivo do cancelamento</label>
                    <input
                        type="text"
                        name="motivo"
                        placeholder="Motivo do cancelamento"
                        className={`form-control placeholder-dark-45 h-100 ${
                            formState.errors.motivo && "is-invalid"
                        }`}
                        ref={register({
                            required: "Insira o motivo do cancelamento",
                        })}
                        defaultValue={
                            props.motivoCancelamento?.DS_MOTIVO_CANCELAMENTO
                        }
                    />
                </div>
                <div className="mt-3">
                    <label>Módulo</label>
                    <select
                        className="form-control"
                        name="ID_TIPO_CASO"
                        ref={register()}
                        defaultValue={props.motivoCancelamento?.ID_TIPO_CASO}
                    >
                        <option></option>
                        {lstModulos?.map((modulo) => (
                            <option
                                key={modulo.ID_MODULO}
                                value={modulo.ID_MODULO}
                            >
                                {modulo.DS_MODULO}
                            </option>
                        ))}
                    </select>
                </div>
                <button
                    className={`btn btn-outline-${
                        !props.motivoCancelamento ? "success" : "primary"
                    } font-weight-bold d-flex align-items-center justify-content-center mt-3`}
                    disabled={
                        CadastrarMotivoCancelamentoLoading ||
                        EditarMotivoCancelamentoLoading
                    }
                >
                    {CadastrarMotivoCancelamentoLoading ||
                    EditarMotivoCancelamentoLoading ? (
                        <Spinner size="sm" />
                    ) : !props.motivoCancelamento ? (
                        <FontAwesomeIcon
                            icon={faPlus}
                            size="lg"
                            className="mr-1"
                        />
                    ) : (
                        <FontAwesomeIcon
                            icon={faEdit}
                            size="lg"
                            className="mr-1"
                        />
                    )}
                    {!props.motivoCancelamento ? "Cadastrar" : "Editar"}
                </button>
            </form>
        </OrSpinner>
    );
}
